<div class="indicator">
  @for (i of itemIndexes(); track i) {
    <div
      class="indicator__bullet"
      [class.indicator__bullet--selected]="currentItemIndex === i"
    ></div>
  }
</div>
